<template>
  <div :class="'form-group-w-btn '+classeFormInline">
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" :id="idInput" :name="nameInput" :value="value" :disabled="inputDisabled">
      <label class="custom-control-label" :for="idInput">&nbsp;{{labelInput}}</label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InputCheckboxGroup',
  props: {
    idInput: {
      type: String,
      required: true
    },
    nameInput: {
      type: String,
      required: true
    },
    classeFormInline: {
      type: String,
      required: false
    },
    value: {
      type: String,
      required: false
    },
    labelInput: {
      type: String,
      required: false,
      default: function () {
        return ''
      }
    },
    // typeInput: {
    //   type: String,
    //   required: false,
    //   default: function () {
    //     return 'text'
    //   }
    // },
    // inputMask: {
    //   type: Array,
    //   required: false,
    //   default: function () {
    //     return null
    //   }
    // },
    inputDisabled: {
      type: String,
      required: false,
      default: function () {
        return null
      }
    },
  },
  methods: {
    clear () {
      document.getElementById(this.idInput).value = ''
    }
  }
}
</script>

<style scoped>

</style>
